import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {

  private readonly subscriptionApiUrl = `${environment.subscriptionApiUrl}/`;
  private readonly subscriptionRouteBase = 'Subscriptions';
  
  constructor(private http: HttpClient) {
    
  }

  retrieveSubscription(): Observable<Array<any>> {
    return this.http.get<Array<any>>(
      `${environment.apiVersionUrl}SubscriptionPortal/retrieveSubscription`
    );
  }

  getModuleRedirectionURL(
    moduleId: number,
    userName: string,
    externalUserGuid: string
  ): Observable<any> {
    const encodedUserName = encodeURIComponent(userName);
    return this.http.get<any>(
      `${this.subscriptionApiUrl}${this.subscriptionRouteBase}/RedirectionURLforModule?moduleId=${moduleId}&username=${encodedUserName}&ExternalUserGUID=${externalUserGuid}`
    );
  }

  checkClientModule(universalId: string, moduleId: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${environment.apiVersionUrl}ClientStore/module-check?universalId=${encodeURIComponent(universalId)}&moduleId=${moduleId}`
    );
  }
}
